export class FormFieldConfig {
  id: string;
  label: string;
  name: string;
  value: any = {};
  simpleMode = false;
  searchUrl: string;
  searchableFields: any[] = [];
  type: string = 'text';
  checkboxOptions: any[] = [];
  visible: boolean = true;
  disabled: boolean = false;
  innerPropertyName: string;
  clickMethod: any;
  executing :any
  elementdata: any;
  styleClass: string;
  idList: any[] = []; // liste des id
  entiteList: any[] = []; // liste des entites
  displayedColumns: any[] = [];
  isDynamic: boolean = false;
  documentLinkName: string = '';
  referenceField: string = '';
  parametreName: string;
  parameterLinkName: string;
  linkedEntite: string;
  dropdownList: any = [];
  checkBoxEntite: string;
  checkBoxLabelTitre: string;
  checkBoxValueTitre: string;
  entiteRelationProperte: any;
  isSimpleMode: boolean;
  isModifiable: boolean;
  isVisible: boolean;
  isGauche = false;
  isAdroite = false;
  editMode: boolean = false;
  multilangueFields: any;
  locals: Map<string, any> = new Map<string, any>();
  images: any = {};
  uploadPath: string;
  uploadUrl: string;
  displayMode: string;
  displayProperty: string;
  isMultiLangue = false;
  labelLocal: any;
  singleImageMode = false;
  entiteClassSelection = false;
  entity: string;
  visibilityCheckProperte = '';
  visibilityCheckValue = '';
  typeName = '';
  imagesmap = {};
  filter: any;
  isList = false;
  languages: any[] = [];
  validationFields: any[] = [];
  isavalidationField = false;

  constructor() {}
}
